import { useContext } from "react";
import SocketIOContext from "./contexts/Kiosk/SocketProvider/SocketIOContext";

const flexBackgroundfunc = theme => {
  return {
    background: theme.headerFooterBGColor || "rgb(60, 183, 76)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    //justifyContent: "center",
    height: "100vh",
    width: "100vw",
    paddingLeft: "0px",
    paddingTop: "0px", //Fix for Grid leaving space at the bottom
    overflow: "hidden"
    //maxWidth: "800px",
    //marginLeft: "auto"
  };
};

const flexBackgroundOrangefunc = theme => {
  return {
    backgroundColor: "orange",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    //justifyContent: "center",
    height: "100vh",
    width: "100vw",
    paddingLeft: "0px",
    paddingTop: "0px" //Fix for Grid leaving space at the bottom
    //maxWidth: "800px",
    //marginLeft: "auto"
  };
};

const logofunc = theme => {
  return {
    marginTop: "3.6vh",
    marginBottom: "2.3vh",
    height: "5.5vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "8.5vw",
    marginRight: "8.5vw"
  };
};

const instructionDivfunc = theme => {
  return {
    marginBottom: "3.3vh",
    height: "7.5vh",
    //color: "white",
    color: theme.headerFooterTextColor,
    //fontSize: "2.4vh",
    fontSize: "2vh",
    width: "83vw",
    textAlign: "center"
  };
};

const instructionVerticallyAlignDivfunc = theme => {
  return {
    position: "relative",
    top: "50%",
    transform: "translateY(-50%)"
  };
};

const whiteDivfunc = theme => {
  return {
    height: "69.7vh",
    width: "100vw",
    backgroundColor: theme.innerBGColor || "white",
    color: theme.innerTextColor || "black"
  };
};

const flexcenterDivfunc = theme => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
    //justifyContent: "space-around"
  };
};

const footerDivfunc = theme => {
  return {
    height: "8.2vh",
    width: "83vw",
    display: "flex",
    flexDirection: "column",
    //alignItems: "center"
    justifyContent: "center"
  };
};

/* flexbox centered colmuns */

const biRowNumberSelectfunc = theme => {
  return {
    //marginBottom: "2vw",
    display: "flex",
    justifyContent: "center",
    gap: "2vw"
  };
};

const InfoTextfunc = theme => {
  return {
    fontSize: "2.3vh"
  };
};

const blackCornedDivReturningContainerfunc = theme => {
  return {
    borderRadius: "1.5vh",
    backgroundColor: theme.telephoneConfirmDivColor || "black",
    color: theme.telephoneConfirmTextColor || "white",
    width: "42vw",
    height: "100%",
    padding: "3.1vh 4vh 3.1vh 4vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  };
};

const configurationfunc = theme => {
  return {
    instructionDiv: {
      margin: "auto"
    },
    whitecontentdiv: {
      width: "83vw",
      height: "100%",
      justifyContent: "center",
      display: "flex",
      flexDirection: "column"
    },
    enterkeytext: {
      fontSize: "4vh",
      textAlign: "center",
      marginBottom: "5vh"
    },
    buttoncontainer: {
      width: "100%",
      height: "auto",
      justifyContent: "center",
      display: "flex",
      flexDirection: "column"
    },
    buttondiv: {
      width: "36vw",
      marginLeft: "auto",
      marginRight: "auto"
    },
    nextbutton: {
      height: "7vh",
      marginBottom: "0px",
      fontSize: "2vh"
    },
    confirmcancelbutton: {
      height: "6vh",
      width: "30vw",
      fontSize: "2vh",
      // marginLeft: "auto",
      // marginRight: "auto",
      margin: "1vh",
      // backgroundColor: theme.mainscreenButtonsBGColor || "white",
      // color: theme.mainscreenButtonsTextColor || "rgb(39, 167, 55)"
      backgroundColor: "white",
      color: "black"
    },
    confirmnextbutton: {
      height: "6vh",
      width: "30vw",
      fontSize: "2vh",
      // marginLeft: "auto",
      // marginRight: "auto",
      margin: "1vh",
      backgroundColor: "black",
      color: "white"
    }
  };
};

const languageselectfunc = theme => {
  return {
    flexBackground: {
      background: theme.mainscreenBGColor || "rgb(60, 183, 76)",
      background:
        theme.mainscreenBGColor ||
        "linear-gradient(130deg, rgba(60, 183, 76) 0%, rgba(60, 183, 76) 60%, rgba(83, 192, 98,1) 80%, rgba(105, 200, 116,1) 100%)",
      //backgroundImage: "url(/img/BottlePattern.svg)",  //as per https://gitlab.com/tgayef/lt3-kiosk/-/issues/28
      //backgroundSize: "310px 310px",
      //backgroundRepeat: "repeat",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      //justifyContent: "center",
      height: "100vh",
      width: "100vw",
      paddingLeft: "0px",
      paddingTop: "0px" //Fix for Grid leaving space at the bottom
      //maxWidth: "800px",
      //marginLeft: "auto"
    },
    logo: {
      marginTop: "6vh",
      marginBottom: "5vh",
      height: "6vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginLeft: "8.5vw",
      marginRight: "8.5vw"
    },
    qrdiv: {
      //marginBottom: "4.6vh",
      height: "24vh",
      width: "83vw",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginLeft: "8.5vw",
      marginRight: "8.5vw",
      borderRadius: "1.8vh",
      backgroundColor: theme.quickStartQRDivColor || "black",
      color: theme.quickStartQRTextColor || "white"
    },
    qrtextelement: {
      width: "45vw",
      height: "100%",
      marginRight: "3vw",
      marginLeft: "2vw",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    },
    qrelement: {
      marginLeft: "1.5vh",
      height: "20vh",
      width: "20vh",
      borderRadius: "0.4vh",
      backgroundColor: theme.quickStartQRBGColor || "white",
      display: "flex",
      padding: "1vw"
    },
    donatediv: {
      //marginBottom: "4.6vh",
      height: "14vh",
      width: "83vw",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginLeft: "8.5vw",
      marginRight: "8.5vw",
      borderRadius: "1.8vh",
      backgroundColor: theme.quickStartQuickDonateDivColor || "black",
      color: theme.quickStartQuickDonateTextColor || "white"
    },
    donationButtonIcon: {
      marginLeft: "1.5vh",
      height: "10vh",
      width: "20vh",
      borderRadius: "0.4vh",
      backgroundColor: theme.quickStartQuickDonateBGColor || "white",
      color: theme.quickStartQuickDonateIconColor || "black",
      padding: "1vw",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center"
    },

    title: {
      //marginBottom: "5vh",
      marginBottom: "7.5vh",
      height: "14.9vh",
      width: "83vw",
      //fontSize: "4.7vh",
      fontSize: "6.7vh",
      //fontSize: "7.5vh",
      textAlign: "center",
      color: theme.mainscreenTextColor || "white"
    },
    button: {
      //marginBottom: "6.8vh",
      height: "7.3vh",
      width: "83vw"
      //fontSize: "4.7vh",
      //color: "white"
    },
    innerbutton: {
      backgroundColor: theme.mainscreenButtonsBGColor || "white",
      color: theme.mainscreenButtonsTextColor || "rgb(39, 167, 55)",
      fontSize: "3vh",
      //border: "0px solid white"
      border: "0px solid " + (theme.mainscreenButtonsBGColor || "white")
    },
    languagediv: {
      //marginBottom: "6.8vh",
      width: "83vw"
      //fontSize: "4.7vh",
      //color: "white"
    }
  };
};

const languagebuttonfunc = theme => {
  return {
    languagebuttonwidget: {
      margin: "0vh 0.6vh 0vh 0.6vh",
      // paddingLeft: "2vw",
      // paddingRight: "2vw",
      padding: "1vw 3.5vw",
      height: "6vh",
      //minHeight: "23px",
      textTransform: "capitalize",
      //fontSize: "1.6vw"
      fontSize: "2.2vh",
      borderRadius: "0.4vh",
      backgroundColor: theme.languageButtonBGColor || "black",
      color: theme.languageButtonTextColor || "rgb(255, 255, 255)"
    },
    smallerlanguagebuttonwidget: {
      margin: "0.15vh 0.6vh 0.15vh 0.6vh",
      // paddingLeft: "2vw",
      // paddingRight: "2vw",
      padding: "1vw 3.5vw",
      height: "5.7vh",
      //minHeight: "23px",
      textTransform: "capitalize",
      //fontSize: "1.6vw"
      fontSize: "2vh",
      borderRadius: "0.4vh",
      backgroundColor: theme.languageButtonBGColor || "black",
      color: theme.languageButtonTextColor || "rgb(255, 255, 255)"
    }
  };
};

const envDisplayfunc = theme => {
  return {
    position: "relative",
    height: "0px",
    color: "yellow",
    fontSize: "1.9vh",
    top: "-2.9vh", //calc(-1.9vh - 1vh)
    fontWeight: "bold"
  };
};

const charitiesfunc = theme => {
  return {
    selectInstruction: {
      width: "90vw",
      textAlign: "center",
      //fontSize: "clamp(6px, 3.4vh, 33px)",
      fontSize: "3.4vh",
      marginBottom: "0.5vh"
    },
    charityElement: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      //backgroundColor: "red",
      backgroundColor: theme.charityElementBgColor || "white",
      //width: "20vh",
      //height: "20vh",
      flex: "1",
      //minWidth: 'calc(50% - 5px)',
      //minWidth: "14vh",
      minWidth: "10vh",
      aspectRatio: "1",
      margin: "0.2vh",
      borderRadius: "1.5vh" /* Rounded corners */,
      boxShadow:
        "0 0.5vh 0.75vh -0.125vh rgba(0, 0, 0, 0.1), 0 0.25vh 0.5vh -0.125vh rgba(0, 0, 0, 0.06)" /* Soft shadow */,
      padding: "1.5vh"
    },
    charityElementTitle: {
      fontSize: "1.4cqh",
      textAlign: "center"
    },
    charityElementDescription: {
      fontSize: "1.2cqh",
      textAlign: "center"
      // height: "3vh",
      // overflow: "clip"
    },
    charityElementLogo: {
      width: "100%",
      aspectRatio: "2/1",
      objectFit: "scale-down"
    },
    charityElementDefaultLogoIcon: {
      color: theme.charityElementButtonColor || "rgb(39, 167, 55)",
      width: "100%",
      height: "50%",
      aspectRatio: "2/1",
      "& svg": {
        width: "100%",
        height: "50%"
      }
    },
    charityElementButton: {
      fontSize: "1.2cqh",
      padding: "0.3cqh 0.6cqh",
      color: theme.charityElementButtonColor || "black",
      borderColor: theme.charityElementButtonColor || "black", // Border color (for outlined variant)
      backgroundColor: theme.charityElementButtonBGColor || "",
      // "&:hover": {
      //   backgroundColor: "#your-hover-bg-color",
      //   borderColor: "#your-hover-border-color"
      // }
      minWidth: "0",
      textTransform: "none"
    },
    charitySearchButton: {
      backgroundColor: theme.charityFindButtonColor || "black",
      textTransform: "none" // This makes it regular casing (removes uppercase)
    },
    charityModalTextColor: {
      color: theme.charityModalTextColor || "black"
    }

    // ConfirmSelect: {
    //   instruction: {

    //   }
    // }
  };
};

const textButtonsfunc = theme => {
  return {
    //margin: "25px 12px 25px 12px",
    margin: "1vh 0vh 1vh 0vh",
    padding: "1vh 6.2vh",
    height: "6vh",
    textTransform: "capitalize",
    //fontSize: "1.6vw"
    fontSize: "2.3vh",
    borderRadius: "1.2vh"
  };
};

const modalsfunc = theme => {
  return {
    printererrormodal: {
      title: {
        color: "black",
        textAlign: "center",
        fontWeight: "bold",
        marginBottom: "2vh"
      },
      iconcontainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
      },
      icon: { fontSize: "10vh", marginBottom: "2vh" },
      body: {
        width: "66vw",
        fontSize: "2.4vh",
        textAlign: "center"
      },
      buttonstyle: {
        margin: "3vh 0vh 1vh 0vh",
        padding: "1vh 6.2vh",
        height: "6vh",
        textTransform: "capitalize",
        fontSize: "2.3vh",
        borderRadius: "1.2vh"
      }
    }
  };
};

export const useKioskVerticalStyles = () => {
  const { getKioskTheme } = useContext(SocketIOContext);
  const theme = getKioskTheme();

  console.log("[useKioskVerticalStyles] theme", theme);

  return {
    flexBackground: flexBackgroundfunc(theme),
    flexBackgroundOrange: flexBackgroundOrangefunc(theme),
    logo: logofunc(theme),
    instructionDiv: instructionDivfunc(theme),
    instructionVerticallyAlignDiv: instructionVerticallyAlignDivfunc(theme),
    whiteDiv: whiteDivfunc(theme),
    flexcenterDiv: flexcenterDivfunc(theme),
    footerDiv: footerDivfunc(theme),
    biRowNumberSelect: biRowNumberSelectfunc(theme),
    InfoText: InfoTextfunc(theme),
    blackCornedDivReturningContainer: blackCornedDivReturningContainerfunc(
      theme
    ),
    configuration: configurationfunc(theme),
    languageselect: languageselectfunc(theme),
    languagebutton: languagebuttonfunc(theme),
    envDisplay: envDisplayfunc(theme),
    charities: charitiesfunc(theme),
    textButtons: textButtonsfunc(theme),
    mainThemeColor: theme.primaryColor,
    primaryColor: theme.primaryColor,
    secondaryColor: theme.secondaryColor,
    trinaryColor: theme.trinaryColor,
    quickStartQRCodeColor: theme.quickStartQRCodeColor,
    quickStartQRBGColor: theme.quickStartQRBGColor,
    quickStartQRTextColor: theme.quickStartQRTextColor,

    modals: modalsfunc(theme)
  };
};
